var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('isotope-slide',{staticClass:"stepup-biometric"},[_vm._v("\n    Biometric\n")])}
var staticRenderFns = []

export { render, staticRenderFns }